import i18next from "i18next";
import { FEATURES, hasFeatureAccess } from "./featureAccess";

export const FIXTURE_WORKSPACE_REGISTRY = Object.freeze([
  { id: "legacy", titleKey: "fixtureWorkspaces.legacy", titleDe: "Bisherige Ansicht", titleEn: "Previous view", access: null, component: null, experimental: false },
  { id: "workspace", titleKey: "fixtureWorkspaces.workspace", titleDe: "Arbeitsbereich", titleEn: "Workspace", access: FEATURES.MATCH_ANALYSIS_COCKPIT, component: "FixtureWorkspacePanel", experimental: false },
  { id: "workspace-full", titleKey: "fixtureWorkspaces.full", titleDe: "Arbeitsbereich 2 – Komplettansicht", titleEn: "Workspace 2 – Full View", access: FEATURES.MATCH_ANALYSIS_FULL_VIEW, component: "FixtureFullView", experimental: true, number: 2 },
  { id: "experiment", titleKey: "fixtureWorkspaces.experiment", titleDe: "Experimenteller Spiel-Arbeitsbereich", titleEn: "Experimental match workspace", access: FEATURES.EXPERIMENTAL_FIXTURE, component: "ExperimentalFixtureWorkspace", experimental: true },
]);

export const fixtureWorkspaceViewsForUser = (user) => FIXTURE_WORKSPACE_REGISTRY
  .filter((view) => !view.access || hasFeatureAccess(view.access, user))
  .map((view) => {
    const fallback = String(i18next.language || "de").startsWith("en") ? view.titleEn : view.titleDe;
    const translated = i18next.t(view.titleKey, { defaultValue: fallback });
    return { ...view, title: translated && translated !== view.titleKey ? translated : fallback };
  });

export const canUseFixtureWorkspaceView = (id, user) =>
  fixtureWorkspaceViewsForUser(user).some((view) => view.id === id);
